/** Same storage shape as LoginWithOTP (`JSON.stringify(Teacher_id)`). Must match JWT userId when calling report/teacher/:teacherId — server returns 403 if mismatched. */
export function getStoredTeacherId() {
  try {
    const raw = localStorage.getItem("Teacher_id");
    if (!raw || raw === "null") return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/** Optional legacy filter for GET .../balance/self */
export function getStoredAcademicYearSessionId() {
  try {
    const raw = localStorage.getItem("academicYearSessionId");
    if (!raw || raw === "null") return undefined;
    const v = JSON.parse(raw);
    if (!v || v === "") return undefined;
    return typeof v === "string" ? v : String(v);
  } catch {
    return undefined;
  }
}

export function startOfDayISO(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d.toISOString();
}

export function endOfDayISO(date) {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d.toISOString();
}

/** Leave API expects UTC midnight for date-only semantics */
export function toUtcMidnightIso(date) {
  const d = new Date(date);
  return new Date(
    Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0),
  ).toISOString();
}
